const TREE = [

    //Sonntag
    [
        
    ],

    //Montag
    [
        
    ],

    //Dienstag
    [
        {
            time: "11:00-12:00",
            title: "Workout 50+",
            size:19, 
        }
    ],


    //Mittwoch
    [
        
    ],


      //Donnerstag
    [
        {
            time: "19:00-20:00",
            title: "Functional",
            size:19, 
        }
  
    ],

    //Freitag
    [
        {
            time: "17:30-18:00",
            title: "Les Mills Core® (CX)",
            size:19
        },
        {
            time: "18:10-19:10",
            title: "Body Balance®",
            size:19
        }
    ],

    //Samstag
    [
        {
            time: "10:30-12:00",
            title: "Functional",
            size:19,
            
        }
    ],

];

const DAYS = [
    "Sonntag",
    "Montag",
    "Dienstag",
    "Mittwoch",
    "Donnerstag",
    "Freitag",
    "Samstag"
];


export {TREE, DAYS};